<script>
  //import Object3D from './Object3D.svelte'
  //import Aframe from './Aframe.svelte'
  import Three from '/components/Atoms/Three.svelte'

  export let zIndex = 0, show = true

</script>

<div class:show class="layer3d">
  <Three {zIndex} doRender={show}/>
</div>
